import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { HERO_URL, WHATSAPP_LINK, CALL_LINK } from "../data";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-28 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_URL}
          alt="Tacos de barbacoa"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-brand-base/85" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-base via-brand-base/80 to-brand-base/70" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 26 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="relative z-10 max-w-3xl mx-auto px-6 text-center"
      >
        <p className="text-brand-gold uppercase tracking-[0.35em] text-xs mb-5">
          Tu mesa te espera
        </p>
        <h2 className="font-display text-4xl md:text-5xl font-bold text-brand-cream leading-[1.1]">
          Haz tu pedido y prueba la
          <span className="block text-brand-gold italic mt-2">
            auténtica barbacoa Castañón
          </span>
        </h2>
        <p className="mt-6 text-brand-sand text-lg max-w-xl mx-auto">
          Pide por WhatsApp o llámanos. Recién hecha, jugosa y con el sabor de
          casa que ya es tradición en La Junta.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#menu"
            data-testid="final-whatsapp-btn"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 bg-brand-gold text-brand-base font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-brand-cream transition-colors duration-300"
          >
            <WhatsAppIcon className="w-5 h-5" />
            Haz tu pedido en línea
          </a>
          <a
            href={CALL_LINK}
            data-testid="final-call-btn"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 border border-brand-gold text-brand-gold font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-brand-gold hover:text-brand-base transition-colors duration-300"
          >
            <Phone className="w-5 h-5" />
            Llamar ahora
          </a>
        </div>
      </motion.div>
    </section>
  );
};
